<template>
  <div  class="commenterImage" >
    <div class="card card-desafio" >
      <div style="padding:20px">
        <h5>{{arkidian.alias}}</h5>
        <router-link
         
          :to="'/Perfil/'+arkidian.usuario"
          tag="div"
          style="cursor:pointer"
        >
          <arkidian
            style="background-color:#e0e0e0; margin-bottom:20px; border-radius:50%; width:150px; padding:20px"
            :preferencias="preferencias"
          ></arkidian>
        </router-link>

        <b-button
          @click="entrarComoArkidian(arkidian)"
          style="width:100%; margin-bottom:10px"
          pill
          variant="success"
        >Entrar</b-button>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import Arkidian from "../shared/Arkidian";

export default {
  props: ["arkidian"],
  data() {
    return {
      loginArkidian: document.location.host+'#/Login/inicio',
      preferencias: {
        color: "",
        body: "",
        face: "",
        hair: "",
        avatar: "",
        animated: false
      }
    };
  },
  components: {
    arkidian: Arkidian
  },
  computed: {
    ...mapGetters([
      "categorias",
      "userLogged",
      "pathAPI",
      "challengeSeleccionado"
    ])
  },
  methods: {
    entrarComoArkidian(arkidian){
      this.hacerLogin(arkidian)
      console.log(arkidian)

    },

    hacerLogin(arkidian) {
      var self = this;
      self.errorMessage = "";

      fetch(this.$store.state.pathAPI + "login.php", {
        method: "POST",
        body: "usuario=" + arkidian.usuario + "&password=" + arkidian.password,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var loginResponse = response.json();
          loginResponse.then(function(result) {
            if (result.resultado == "ERROR") {
              console.log("error al login")
            } else {
              if (result.mensaje == "") {
                console.log(document.location.host)
                var urlLogin = '#/Login/'+result.token
                window.open(urlLogin, '_blank');
              }
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },



    verPerfil(arkidian) {
      sessionStorage.usuarioSeleccionado = this.arkidian.usuario;
      this.$store.state.usuarioSeleccionado = this.arkidian.usuario;
      this.$router.push({ path: "/Perfil" });
    }
  },
  mounted: function() {

    if (this.arkidian.arkidian_usuario[0]) {
      this.preferencias.body = this.arkidian.arkidian_usuario[0].cuerpo;
      this.preferencias.color =
        "fill:#" + this.arkidian.arkidian_usuario[0].color;
      this.preferencias.hair = this.arkidian.arkidian_usuario[0].pelo;
      this.preferencias.face = this.arkidian.arkidian_usuario[0].cara;
      this.preferencias.avatar = this.arkidian.avatar;
    } else {
      this.preferencias.avatar = this.arkidian.avatar;
    }

  }
};
</script>

<style scoped>
.card-desafio {
  background: #ececec;
  border-radius: 15px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  z-index: 0;
  margin: 10px;
}

.card-desafio:hover {
  box-shadow: -1px 11px 16px 1px rgba(0, 0, 0, 0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
}

.card-desafio-image {
  border-radius: 10px;
  width: 200px;
}
@media screen and (max-width: 600px) {
  .card-desafio {
    width: 250px;
    margin: 20px;
  }
  .card-desafio-image {
    border-radius: 10px;
    width: 250px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/arkidian/Arkidian.vue